import { useTranslation } from 'react-i18next';

import { validationMessageKey } from '@/utils/validationMessage';

/**
 * Zod carries translation keys as messages. They are resolved through the hook's `t`, never the
 * i18n singleton, so a language switch re-renders them with the rest of the form.
 */
export const useFormErrorMessage = () => {
    const { t } = useTranslation();

    return (message?: string, options?: Record<string, unknown>): string | undefined =>
        message ? t(validationMessageKey(message), options) : undefined;
};
